import { StyleSheet } from 'react-native';
import { spacing } from '../../../shared/theme/spacing'
import { ticketColors } from '../../../shared/theme/ticketColors';

/** Shell compartido: detalle y edición de datos maestros (ticket line). */
export const mastersModalStyles = StyleSheet.create({
  modalBackdropFlex: {
    flex: 1,
  },
  modalBackdrop: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: ticketColors.dim,
  },
  modalCard: {
    width: '100%',
    maxHeight: '96%',
    backgroundColor: ticketColors.paper,
    borderRadius: 14,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    overflow: 'hidden',
  },
  sheetCard: {
    width: '100%',
    maxHeight: '96%',
    backgroundColor: ticketColors.paper,
    borderTopLeftRadius: 24,
    borderTopRightRadius: 24,
    borderTopWidth: 1,
    borderColor: ticketColors.ruleSoft,
    paddingTop: 8,
  },
  keyboardWrap: {
    width: '100%',
    // Acota el KAV al backdrop: sin esto el maxHeight % del sheet no resuelve en web
    maxHeight: '100%',
    justifyContent: 'flex-end',
  },
  grabber: {
    width: 28,
    height: 3,
    borderRadius: 2,
    backgroundColor: ticketColors.rule,
    alignSelf: 'center',
    marginTop: 2,
    marginBottom: 12,
  },
  modalScroll: {
    flexShrink: 1,
  },
  modalScrollContent: {
    gap: spacing.lg,
    padding: spacing.md,
    paddingBottom: spacing.xl,
  },
  modalActionsDock: {
    flexShrink: 0,
    padding: spacing.md,
    borderTopWidth: 1,
    borderTopColor: ticketColors.rule,
    backgroundColor: ticketColors.paper,
  },
  heroStatusRow: {
    marginTop: spacing.xs,
  },
});
